"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortableList = void 0;
/** @jsx jsx */
var react_1 = __importDefault(require("react"));
var react_2 = require("@emotion/react");
var core_1 = require("@dnd-kit/core");
var sortable_1 = require("@dnd-kit/sortable");
var Styles_1 = __importDefault(require("./Styles"));
var SortableItem_1 = require("./SortableItem");
var icons_1 = require("../../icons");
function SortableList(_a) {
    var items = _a.items, onChange = _a.onChange, renderItem = _a.renderItem, _b = _a.sortIcon, Icon = _b === void 0 ? icons_1.Drag : _b, _c = _a.sortingEnabled, sortingEnabled = _c === void 0 ? true : _c;
    var sensors = core_1.useSensors(core_1.useSensor(core_1.PointerSensor), core_1.useSensor(core_1.KeyboardSensor, {
        coordinateGetter: sortable_1.sortableKeyboardCoordinates,
    }));
    return (react_2.jsx(core_1.DndContext, { sensors: sensors, onDragEnd: function (_a) {
            var active = _a.active, over = _a.over;
            if (over && active.id !== (over === null || over === void 0 ? void 0 : over.id)) {
                var activeIndex = items.findIndex(function (_a) {
                    var id = _a.id;
                    return id === active.id;
                });
                var overIndex = items.findIndex(function (_a) {
                    var id = _a.id;
                    return id === over.id;
                });
                var sortedArray = sortable_1.arrayMove(items, activeIndex, overIndex);
                console.log(sortedArray);
                onChange(sortedArray);
            }
        } },
        react_2.jsx(sortable_1.SortableContext, { items: items },
            react_2.jsx("ul", { css: Styles_1.default.sortableList, role: "application" }, items.map(function (item, itemIndex) { return (react_2.jsx(react_1.default.Fragment, { key: item.id }, sortingEnabled ? (react_2.jsx(SortableItem_1.SortableItem, { id: item.id }, renderItem(item, itemIndex, react_2.jsx(SortableItem_1.DragHandle, { sortIcon: Icon, sortingEnabled: sortingEnabled }), sortingEnabled))) : (renderItem(item, itemIndex, react_2.jsx(SortableItem_1.DragHandle, { sortIcon: Icon, sortingEnabled: sortingEnabled }), sortingEnabled)))); })))));
}
exports.SortableList = SortableList;
exports.default = SortableList;
